<template>
    <div class="d-flex flex-column flex-root">
        <div class="d-flex flex-row flex-column-fluid page">
            <div id="kt_wrapper" class="d-flex flex-column flex-row-fluid wrapper">
                <div id="kt_content" class="content d-flex flex-column flex-column-fluid">
                    <div class="d-flex flex-column-fluid">
                        <div class="container">
                            <div class="d-lg-flex flex-row-fluid">
                                <div class="content-wrapper flex-row-fluid">
                                    <!-- Start -->
                                    <div class="row d-flex justify-content-center mt-lg-30">
                                        <div class="col-xl-6">
                                            <div class="d-flex flex-center mt-10 mb-10">
                                                <a href="https://hashtastic.eu">
                                                    <img
                                                        src="media/logos/hashtastic-logo-2.png"
                                                        class="max-h-25px"
                                                        alt=""
                                                    />
                                                </a>
                                            </div>
                                            <transition name="fade-in-up">
                                                <router-view />
                                            </transition>
                                        </div>
                                    </div>
                                    <!-- End -->
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import { mapGetters } from "vuex";
export default {
    name: "Auth",
    mounted() {
        // Set background image
        const bg = this.layoutConfig("self.body.background-image");
        document.body.style.backgroundImage = `url('${bg}')`;
    },
    computed: {
        ...mapGetters(["layoutConfig"]),
    },
};
</script>
